import { notificationAPI, muvekkilAPI, MUVEKKIL_TOKEN_KEY } from '../api/api';

/*
  UYGULAMA HATALARI SUNUCU KAYDINA

  Kullanici telefonda "hata veriyor" dediginde hatanin metnini goremiyorduk;
  ekran goruntusu istemek ya da tahmin etmek zorunda kaliyorduk. Artik
  uygulamada (Capacitor) yakalanmayan her hata ve sayfa coktugunde
  (RouteErrorBoundary) kisa bir satir sunucu kaydina yaziliyor:
  "Tani [personel N] hata: ...". Ayni hata bir oturumda bir kez yazilir.
*/
const gonderilen = new Set();

const uygulamada = () => {
  try { return document.body.classList.contains('capacitor-native'); } catch (e) { return false; }
};

export const hatayiKaydet = (kaynak, hata, ek = '') => {
  try {
    if (!uygulamada()) return;
    const mesaj = String((hata && (hata.message || hata.reason?.message)) || hata || 'bilinmeyen').slice(0, 160);
    const anahtar = `${kaynak}:${mesaj}`;
    if (gonderilen.has(anahtar) || gonderilen.size > 20) return;
    gonderilen.add(anahtar);
    const yigin = String(hata?.stack || '').split('\n').slice(0, 3).join(' | ').slice(0, 220);
    const metin = `${kaynak} yol=${window.location.pathname} mesaj=${mesaj}${ek ? ` ${ek}` : ''}${yigin ? ` yigin=${yigin}` : ''}`;
    if (localStorage.getItem('token')) notificationAPI.tani('hata', metin);
    else if (localStorage.getItem(MUVEKKIL_TOKEN_KEY)) muvekkilAPI.tani('hata', metin);
  } catch (e) { /* kayit hatasi uygulamayi bozmasin */ }
};

export const hataKaydiniBaslat = () => {
  window.addEventListener('error', (e) => hatayiKaydet('window', e.error || e.message));
  window.addEventListener('unhandledrejection', (e) => {
    // Sunucunun reddettigi istekler (401, 404...) zaten sunucu kaydinda var.
    if (e.reason && e.reason.isAxiosError) return;
    hatayiKaydet('promise', e.reason);
  });
};
